import { render, staticRenderFns } from "./mailYcelAdd.vue?vue&type=template&id=d001cc68"
import script from "./mailYcelAdd.vue?vue&type=script&lang=js"
export * from "./mailYcelAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports